// src/components/StepFinal_Gracias.js
import React from 'react';
import { Container, Button } from 'react-bootstrap';


export default function StepFinalGracias({ reset }) {

  const phone = "59891244820";
  const message = encodeURIComponent("Hola, te contacto desde la web https://www.terminaelliceo.org/ ");

  return (
    <Container className="form-container text-center">

      <h2 className="form-title">¡Muchas gracias por tu postulación y felicitaciones por querer terminar el liceo!</h2>
      <p>Con el fin de avanzar en el proceso, te agradecemos solicitar tu escolaridad en cualquier liceo público del país. En caso de que te soliciten un destino, indicá "Becas Ciclo".</p>
      <p>Una vez que la tengas, cargala en <a href="/escolaridad">este enlace</a>.</p>
      <p>Por cualquier duda, comunicate al <a href={`https://wa.me/${phone}?text=${message}`} target="_blank" rel="noopener noreferrer">091 244 820</a>.</p>

      <Button variant="primary" onClick={reset} className="mt-3 botonfinalreiniciar">
        Reiniciar formulario
      </Button>
    </Container>
  );
}
